import React, { memo } from 'react'
import VideoVariantRow from './VideoVariantRow'
import { IVideoDropdownModel } from '../types'

interface IVideoVariantListProps {
  models: IVideoDropdownModel[]
  selectedKey: string | null
  onSelect: (model: IVideoDropdownModel) => void
}

const VideoVariantList: React.FC<IVideoVariantListProps> = ({
  models,
  selectedKey,
  onSelect
}) => (
  <>
    {models.map(model => (
      <VideoVariantRow
        key={model.selectKey}
        model={model}
        isSelected={model.selectKey === selectedKey}
        onSelect={() => onSelect(model)}
      />
    ))}
  </>
)

export default memo(VideoVariantList)
